import { render, staticRenderFns } from "./TrinkgeldBestellung.vue?vue&type=template&id=2c80a824"
import script from "./TrinkgeldBestellung.vue?vue&type=script&lang=ts"
export * from "./TrinkgeldBestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports